<template>
  <v-card class="white elevation-3 ma-4">
    <div class="tabs-div">
      <v-tabs
        v-model="activeTab"
        color="white"
      >
        <v-tab
          v-for="(tab, i) in tabs"
          :key="i"
          active-class="primary--text"
          class="subheading text-capitalize tab-item"
        >
          {{ tab }}
        </v-tab>
      </v-tabs>
      <v-divider/>
    </div>
    <v-tabs-items v-model="activeTab">
      <v-tab-item>
        <hospitals-list />
      </v-tab-item>
      <v-tab-item>
        <hospitals-types @show-hospitals="activeTab = TAB_LIST" />
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>
import { mapMutations } from 'vuex';
import { SET_TITLE } from '@/store/mutations';
import { FETCH_DATA } from '@/store/HospitalsTypes/actions';
import HospitalsList from '@/components/Hospitals/HospitalsList';
import HospitalsTypes from '@/components/Hospitals/HospitalsTypes';

const TAB_LIST = 0;
const TAB_TYPES = 1;

export default {
  components: {
    HospitalsList,
    HospitalsTypes,
  },
  data() {
    return {
      TAB_LIST,
      activeTab: TAB_LIST,
      tabs: [
        this.$t('hospitals.tabs.list'),
        this.$t('hospitals.tabs.types'),
      ],
    };
  },
  watch: {
    activeTab(value) {
      if (value === TAB_TYPES) {
        this.$store.dispatch(`hospitalsTypes/${FETCH_DATA}`);
      }
    },
  },
  mounted() {
    this[SET_TITLE](this.$t('hospitals.header'));
  },
  methods: {
    ...mapMutations([SET_TITLE]),
  },
};
</script>

<style lang="scss" scoped>
.tabs-div {
  padding-bottom: 20px;
}

.tab-item {
  min-width: 130px;
}
</style>

<style lang="scss">
.long-beach-tabs div[class='datatable__actions'] {
  float: right;
}
</style>
